import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ALLOWED_HOSTS } from '@sparro/app/core/config/constants.config';

@Component({
  selector: 'uni-blog-entry-cards-group',
  templateUrl: './blog-entry-cards-group.component.html',
  styleUrls: ['./blog-entry-cards-group.component.scss']
})
export class BlogEntryCardsGroupComponent implements OnInit {
  @Input() entries: any;
  @Input() host: ALLOWED_HOSTS;
  @Input() display: ('grid' | 'breakpoint') = 'grid';
  @Input() featured: boolean = false;
  @Input() self: boolean = false;
  @Input() showCardOptions: boolean = false;
  @ViewChild('grid', { read: ElementRef }) grid: ElementRef;

  constructor(
  ) { }

  ngOnInit(): void {
  }

}
